// Token'ları saklama
export const saveToken = (accessToken, refreshToken) => {
  localStorage.setItem('accessToken', accessToken); // accessToken'ı localStorage'a kaydet
  localStorage.setItem('refreshToken', refreshToken); // refreshToken'ı localStorage'a kaydet
};

// Access Token'ı alma
export const getAccessToken = () => {
  return localStorage.getItem('accessToken'); // localStorage'dan accessToken'ı al
};

// Refresh Token'ı alma
export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken'); // localStorage'dan refreshToken'ı al
};

// Token'ları temizleme
export const clearTokens = () => {
  localStorage.removeItem('accessToken'); // accessToken'ı sil
  localStorage.removeItem('refreshToken'); // refreshToken'ı sil
};
